import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

export default function FilterToggle({
  toggleLabel,
  toggleView,
  showFavoritesToggle,
  checked,
  ...props
}) {
  return (
    // eslint-disable-next-line
    <label className={`custom-filter-toggle ${showFavoritesToggle || ''}`}>
      <span style={{ display: !toggleLabel ? 'none' : 'block' }}>
        {toggleLabel}
      </span>
      <Toggle
        {...props}
        icons={false}
        className="custom-toggle"
        checked={checked}
        onChange={toggleView}
      />
    </label>
  );
}

FilterToggle.propTypes = {
  toggleLabel: PropTypes.string.isRequired,
  toggleView: PropTypes.func.isRequired,
  showFavoritesToggle: PropTypes.string,
  checked: PropTypes.bool.isRequired,
};
